import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useSelector } from "react-redux";
import NoSubscription from "components/no-subscription";
import UpcomingDelivery from "components/upcoming-delivery";
import RenderModules from "helpers/render-modules";
import clsx from "clsx/lite";
import { useGlobalContext } from "context/global";
import SubscriptionProducts from "./products";
import Link from "helpers/link";
import { ReactComponent as BoxIcon } from "assets/svgs/box.svg";
import { editSubscriptionProductsUrl } from "utils/constants";
import { trackViewCancelledDashboard } from "services/analytics";
import { fetchEversubsSubscriptions } from "actions/account/subscription";

const SubscriptionDetails = ({ products, modules, cancelledModules }) => {
	const dispatch = useDispatch();
	const {
		subscriptionId,
		isFetched,
		isActive,
		isCancelled,
	} = useSelector((state) => state.account.subscription);
	const { firstName, displayName } = useSelector((state) => state.account.profile);
	const { translation } = useGlobalContext();

	useEffect(() => {
		if (isCancelled && cancelledModules?.length > 0) {
			trackViewCancelledDashboard(subscriptionId);
			console.log("Track landing page for cancelled subscription");
		}
	}, [isCancelled, cancelledModules, subscriptionId]);

	useEffect(() => {
		if (!isFetched) return;
		dispatch(fetchEversubsSubscriptions());
	}, [dispatch, isFetched]);

	if (!subscriptionId && isFetched) return <NoSubscription />;

	return (
		<section className={clsx(
			"w-full mx-auto mb-10 px-2 md:px-4 lg:px-0",
			"hd-screen-max-width justify-evenly items-start flex flex-col lg:flex-row",
		)}>
			{isCancelled && cancelledModules?.length > 0 ? (
				<div className="w-full md:my-10">
					<h2 className="text-center text-h2-md md:text-h2">
						{translation.account.welcome_back?.replace("{firstname}", firstName || displayName)}
					</h2>
					<RenderModules className="lg:w-90 mx-auto !my-0" modules={cancelledModules} allProducts={products} />
				</div>) : (
				<div className="w-full px-1.5 md:px-0 m-auto flex flex-col">
					<UpcomingDelivery />
					<div className="flex flex-col mb-5">
						<SubscriptionProducts allProducts={products} />
						{isActive && <div className="w-full flex justify-center md:mt-5 pb-2.5">
							<Link to={editSubscriptionProductsUrl} className="manage-products-link">
								<BoxIcon className="mr-2.5" />
								{translation.subscription?.edit_products}
							</Link>
						</div>}
						<div>
							<RenderModules className="lg:w-90 mx-auto" modules={modules} allProducts={products} />
						</div>
					</div>
				</div>)}
		</section>
	);
};

export default SubscriptionDetails;
